"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useResizeObserver = ref => {
  const [element, setElement] = (0, _react.useState)(null);
  const [rect, setRect] = (0, _react.useState)({});
  const observer = (0, _react.useRef)(null);

  //Clean up observer
  const cleanOb = (0, _react.useCallback)(() => {
    if (observer.current) {
      observer.current.disconnect();
    }
  }, []);
  (0, _react.useEffect)(() => {
    setElement(ref.current);
  }, [ref]);
  (0, _react.useEffect)(() => {
    if (!element) return;
    // Element has changed, disconnect old observer
    cleanOb();
    const ob = observer.current = new ResizeObserver(_ref => {
      let [entry] = _ref;
      // inlineSize and blockSize in entry.borderBoxSize and contentBoxSize
      // inlineSize means height when write-mode is horizontal, and width when write-mode is vertical.
      // blockSize means width when write-mode is horizontal, and height when write-mode is vertical.
      // So, for the sake of simplicity, I will use getBoundingClientRect
      setRect(entry.target.getBoundingClientRect());
    });
    ob.observe(element);

    // disconnect when component is unmounted
    return () => {
      cleanOb();
    };
  }, [element]);
  return rect;
};
var _default = exports.default = useResizeObserver;